import { render, staticRenderFns } from "./ModifyPwdModal.vue?vue&type=template&id=c9bf300a&scoped=true"
import script from "./ModifyPwdModal.vue?vue&type=script&lang=js"
export * from "./ModifyPwdModal.vue?vue&type=script&lang=js"
import style0 from "./ModifyPwdModal.vue?vue&type=style&index=0&id=c9bf300a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9bf300a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c9bf300a')) {
      api.createRecord('c9bf300a', component.options)
    } else {
      api.reload('c9bf300a', component.options)
    }
    module.hot.accept("./ModifyPwdModal.vue?vue&type=template&id=c9bf300a&scoped=true", function () {
      api.rerender('c9bf300a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ezpay/system/components/Modal/ModifyPwdModal.vue"
export default component.exports